import { meGetVoteTokensSummary } from '../features/queries/meGetVoteTokensSummary';
import { useQ } from '../lib/query';

/**
 * Hlasovacie žetóny ako jeden fond.
 *
 * Kým hlas mal typ (`important` / `urgent`), API vracalo žetóny rozdelené po
 * typoch a tento hook ich sčítaval, aby ich profil mohol ukazovať ako jeden
 * druh. Typy hlasu zmizli, takže sčítavanie zmizlo s nimi - hook zostáva ako
 * jedno miesto, ktoré fondu dáva mená, na ktoré je zvyknutý zvyšok profilu.
 */
export const useVoteTokensPool = () => {
  const { data, ...queryRes } = useQ(meGetVoteTokensSummary);

  const available = data?.available_tokens ?? 0;
  const active = data?.active_tokens ?? 0;

  return {
    ...queryRes,
    /** Nepoužité žetóny, ktoré vie občan práve teraz dať do hlasovania. */
    available,
    /** Žetóny už vložené do hlasovania. */
    active,
    /** Veľkosť fondu. Server ju drží v konfigurácii, appka ju nepočíta. */
    total: data?.max_count ?? available + active,
  };
};

export default useVoteTokensPool;
